<template #default>
  <v-card
    :height="heightCard"
    elevation="0"
    style="display: flex; flex-direction: column"
  >
    <v-toolbar v-if="title" class="ml-2" elevation="0">
      <v-toolbar-title class="body-bold-medium">
        {{ title }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="showCloseBtn" icon @click="$emit('close-upload', false)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text style="flex: 100%; padding-bottom: 24px; padding-top: 0px">
      <div
        class="dropzone"
        :class="{ 'is-hovered': isHovered }"
        :style="{ height: heightDropzone }"
        @drop.prevent="handleDrop"
        @dragover.prevent
        @dragenter="onDragEnter"
        @dragover="onDragOver"
        @dragleave="onDragLeave"
      >
        <v-icon
          @dragenter="onDragEnter"
          @dragover="onDragOver"
          @dragleave="onDragLeave"
          size="36"
          color="brand-40-dark"
          class="brand-90"
          style="padding: 20px; border-radius: 100%; margin-bottom: 10px"
          >panda-upload</v-icon
        >
        <span @dragover="onDragOver" class="body-regular-base">{{
          $t('message.pages.video.textTitleType')
        }}</span>
        <p @dragover="onDragOver" class="body-regular-small">
          {{ $t('message.pages.video.textSubTitleType') }}
        </p>
        <base-btn
          @dragover="onDragOver"
          class="pa-2"
          type="secondary"
          @click="triggerFileInput"
        >
          {{ $t('message.pages.video.textBtnType') }}
        </base-btn>
        <input
          ref="fileInput"
          type="file"
          accept=".png,.jpg,.jpeg,.gif"
          class="d-none"
          @change="handleFileInput"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import i18next from 'i18next'
export default {
  name: 'UploadDropzone',
  props: {
    title: {
      type: String,
      default: 'Importar Imagem',
    },
    heightCard: {
      type: String,
      default: '600px',
    },
    heightDropzone: {
      type: String,
      default: '100%',
    },
    textTitleType: {
      type: String,
      default: i18next.t('message.pages.video.textTitleType'),
    },
    textSubTitleType: {
      type: String,
      default: i18next.t('message.pages.video.textSubTitleType'),
    },
    textBtnType: {
      type: String,
      default: i18next.t('message.pages.video.textBtnType'),
    },
    showCloseBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isHovered: false,
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileInput(event) {
      const fileInput = event.target
      const file = event.target.files[0]
      if (file) {
        this.emitFile(file)
      }
      fileInput.value = ''
    },
    onDragEnter(event) {
      event.preventDefault()
      this.isHovered = true
    },
    onDragOver(event) {
      event.preventDefault()
      this.isHovered = true
    },
    onDragLeave(event) {
      event.preventDefault()
      this.isHovered = false
    },
    handleDrop(event) {
      const file = event.dataTransfer.files[0]
      if (file) {
        this.emitFile(file)
      }
    },
    emitFile(file) {
      this.$emit('file-uploaded', file)
    },
    closeDialog() {
      this.isOpen = false
    },
  },
}
</script>

<style lang="scss" scoped>
.dropzone {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #edeef1;
  border-color: varFigma(neutral-95-lightest);
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  background-color: varFigma(neutral-99);
}
.dropzone:hover,
.is-hovered {
  background-color: varFigma(neutral-99);
  border: 2px dashed;
  border-color: varFigma(brand-60-base);
}

.d-none {
  display: none;
}
.body-regular-base {
  color: varFigma(neutral-20-dark);
}
</style>
